import ScrollMagic from 'scrollmagic';
import TweenMax from 'gsap';
import TimelineMax from 'gsap/TimelineMax';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';

class BjzmParallax {
	// .bjzm-wrapper--condo
	constructor() {
		if( $(".hero__background-img").length > 0 ) {
			this.doParallaxHero();
		}

		if( $(window).outerWidth() > 991 ) {
			this.doParallaxSections();
			this.doParallaxSectionSwipes();
		}	
		this.doParallaxBgImageSectionSwipes();
		this.doTheJpShuffle();
	}

	doParallaxHeroOld() {
		var controller = new ScrollMagic.Controller({
			globalSceneOptions: {triggerHook: 0, duration: "100%"}
		});
					
		var parallaxEffect = TweenMax.fromTo( ".hero__background-img", 1, { y: "0%", ease: Power0.easeNone }, { y: "20%", ease: Power0.easeNone });

		var scene = new ScrollMagic.Scene({
			triggerElement: ".hero__background-img",
		})
		// .addIndicators()
		.setTween( parallaxEffect )
		.addTo(controller);
	}

	handleScroll() {
		var scrolled = $(window).scrollTop()
		$('.hero__background-img').each(function(index, element) {
			var initY = $(this).offset().top
			var height = $(this).height()
			var endY  = initY + $(this).height()
			var diff = scrolled - initY
			var ratio = (Math.round((diff / height) * 100)) * -1;
			var vertical = 50 + (parseInt(-(ratio * 1.002)) * 0.2);
			$(this).css('background-position','center ' + vertical + '%')
		})
	}

	doParallaxHero() {
		var self = this;
		self.handleScroll();
		$(window).scroll(function() {
			self.handleScroll();
		})
	}

	doParallaxSections() {
		
		var sectionController = new ScrollMagic.Controller({
			globalSceneOptions: {triggerHook: "onEnter", duration: "200%"}
		});

		$(".content-block__ribbon--swipe").each(function() {

			var parallaxEffect = TweenMax.to( $(this), 1, { y: "-100px", ease: Linear.easeNone });

			var scene = new ScrollMagic.Scene({
				triggerElement: this
			})
			// .addIndicators()
			.setTween(parallaxEffect) // trigger a TweenMax.to tween
			.addTo(sectionController);
		  
		});

	}

	doParallaxSectionSwipes() {
		
		var controller = new ScrollMagic.Controller();

		function addVisibleClass(event) {
			$(event.target.triggerElement()).addClass('ribbon-swipe-in')
		}

		$(".content-block__ribbon--swipe").each(function() {

			var scene = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: 1
			})
			// .addIndicators()
			.on('start', addVisibleClass)
			.addTo(controller);
		  
		});

	}

	doParallaxBgImageSectionSwipes() {
		
		var controller = new ScrollMagic.Controller();

		function addVisibleClass(event) {
			$(event.target.triggerElement()).addClass('entering')
		}

		$(".ribbon--image-bg").each(function() {

			var scene = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: 1,
				offset: 330
			})
			// .addIndicators()
			.on('start', addVisibleClass)
			.addTo(controller);
		  
		});

	}
	
	doTheJpShuffle() {
		
		var controller = new ScrollMagic.Controller();

		function addVisibleClass(event) {
			$(event.target.triggerElement()).addClass('entered')
		}

		$(".jp-shuffle").each(function() {

			var scene = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: 1,
				offset: 130
			})
			// .addIndicators()
			.on('start', addVisibleClass)
			.addTo(controller);		  
		});

	}
	
}

module.exports = BjzmParallax;

